'use strict';

var Sugar = require('sugar-core');

require('../enumerable/build/buildFromIndexMethodsCall');

module.exports = Sugar.Array.reduceFromIndex;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/reduceFromIndex.js
// module id = 416
// module chunks = 0